import _pt from "prop-types";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Sparkles = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      title = _ref.title,
      titleId = _ref.titleId;
  var numericSize = size === 'medium' ? 16 : size === 'small' ? 14 : 12;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 18 18",
    "aria-hidden": ariaHidden,
    className: className,
    height: numericSize,
    ref: ref,
    role: "img",
    width: numericSize,
    "aria-labelledby": titleId
  }, title === undefined ? ___EmotionJSX("title", {
    id: titleId
  }, 'Sparkles') : title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("path", {
    fill: color,
    d: "M9.751 11.484c.29.107.521.338.628.628l.642 1.748.566-1.722a.94.94 0 01.601-.601l1.722-.566-1.748-.642a1.06 1.06 0 01-.628-.628l-.642-1.748-.566 1.722a.94.94 0 01-.601.601l-1.722.566 1.748.642zm-5.092.228c-.9-.33-.927-1.593-.04-1.885l3.956-1.302L9.877 4.57c.291-.887 1.555-.86 1.885.04l1.475 4.017 4.016 1.475c.9.33.928 1.593.041 1.885l-3.956 1.302-1.302 3.956c-.292.887-1.555.86-1.885-.04l-1.475-4.017-4.017-1.475zM.72 5.347c-.9-.33-.928-1.594-.041-1.886l1.384-.455.456-1.385c.292-.887 1.555-.86 1.885.04l.516 1.407 1.406.516c.9.33.928 1.593.041 1.885l-1.385.455-.455 1.385c-.292.887-1.555.86-1.886-.04l-.516-1.406L.72 5.347z",
    fillRule: "evenodd"
  }));
});
Sparkles.propTypes = process.env.NODE_ENV !== "production" ? {
  'aria-hidden': _pt.bool,
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf(['xsmall', 'small', 'medium']),
  title: _pt.string,
  titleId: _pt.string
} : {};
export default Sparkles;